module.exports = __webpack_public_path__ + "static/media/006.1b5cbba8.jpg";